import * as React from 'react';

function SvgFileEarmarkRuled(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M14 14V4.5L9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2zM9.5 3A1.5 1.5 0 0011 4.5h2V9H3V2a1 1 0 011-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 01-1-1v-1zm3 2v-2h7v1a1 1 0 01-1 1H6zm7-3H6v-2h7v2z' />
		</svg>
	);
}

export default SvgFileEarmarkRuled;
